import apiClient from './client';

export interface Brand {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBrandDto {
  name: string;
  description?: string;
}

export interface UpdateBrandDto {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export const brandsApi = {
  getAll: async (): Promise<Brand[]> => {
    const response = await apiClient.get('/brands');
    return response.data.map((brand: any) => ({
      ...brand,
      id: brand._id,
    }));
  },

  getOne: async (id: string): Promise<Brand> => {
    const response = await apiClient.get(`/brands/${id}`);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  create: async (data: CreateBrandDto): Promise<Brand> => {
    const response = await apiClient.post('/brands', data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  update: async (id: string, data: UpdateBrandDto): Promise<Brand> => {
    const response = await apiClient.put(`/brands/${id}`, data);
    return {
      ...response.data,
      id: response.data._id,
    };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/brands/${id}`);
  },
};
